import * as React from "react";
import PropTypes from 'prop-types';

const SvgSuccess = props => {
  if (props.id !== "_svgsuccess") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 40 40" {...props}><path fillRule="evenodd" d="M17.73 21.64l9.09-9.09 3 3-12.09 12.16-7.58-7.58 3-3 4.58 4.51zM20 5C11.716 5 5 11.716 5 20c0 8.284 6.716 15 15 15 8.284 0 15-6.716 15-15A15.001 15.001 0 0020 5z" /></svg>;
};

SvgSuccess.displayName = "_svgsuccess";
SvgSuccess.propTypes = {
  id: PropTypes.string
};
SvgSuccess.defaultProps = {
  id: ''
};
export default SvgSuccess;